import React, { useState } from 'react';
import { Translation } from 'react-i18next';
import { Tabs, Space, Button, Typography } from 'antd';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableList, faBorderAll } from '@fortawesome/free-solid-svg-icons';
import useWindowDimensions from '../../../../../lib/WindowDimensions';
import LearningAdminHeaderList from '../containers/LearningAdminHeaderListContainer';
import LearningAdminModuleSeriesGridScreen from '../containers/LearningAdminModuleSeriesGridScreenContainer';
import LearningAdminModuleSeriesTableScreen from '../containers/LearningAdminModuleSeriesTableScreenContainer';
import LearningAdminModulesGridScreen from '../containers/LearningAdminModulesGridScreenContainer';
import LearningAdminModulesTableScreen from '../containers/LearningAdminModulesTableScreenContainer';

import QueryString from '../../../../../lib/QueryString';

const { Text } = Typography;

const LearningAdminList = ({
  page,
  limit,
  filter,
  order,
  view,
  activeKey,
  history,
  component,
  ...props
}) => {
  const [showList, setShowList] = useState(0);
  const [globalTotal, setGlobalTotal] = useState(0);

  const { width } = useWindowDimensions();
  const isMedium = width > 992;

  const onChangeView = (view) => {
    const path = props.location.pathname;
    const params = QueryString.parse(props.location.search);
    params.view = view;
    history.push(QueryString.append(path, params));
  };

  const handleReset = (activeKey) => {
    const path = props.location.pathname;
    const params = QueryString.parse(props.location.search);
    params.view = 'grid';
    params.key = activeKey;
    history.push(QueryString.append(path, params));
  };

  return (
    <Translation>
      {(t) => (
        <>
          <Tabs
            activeKey={activeKey}
            onChange={handleReset}
            style={{ marginTop: '20px' }}
            destroyInactiveTabPane={true}
            type='card'
            className='learning-admin-tabs'
            tabBarExtraContent={
              <>
                {isMedium && (
                  <Text>
                    {t('resource_list_table_show_selected_total', {
                      showList: showList,
                      total: globalTotal,
                    })}
                  </Text>
                )}
                <Space style={{ marginBottom: '6px', marginLeft: '10px' }}>
                  <Button
                    onClick={() => onChangeView('grid')}
                    type='text'
                    className={`${
                      view === 'grid' ? 'btn-view-active' : 'btn-view-desactive'
                    }`}
                  >
                    <FontAwesomeIcon icon={faBorderAll} />
                  </Button>
                  <Button
                    type='text'
                    onClick={() => onChangeView('table')}
                    className={`${
                      view === 'table'
                        ? 'btn-view-active'
                        : 'btn-view-desactive'
                    }`}
                  >
                    <FontAwesomeIcon icon={faTableList} />
                  </Button>
                </Space>
              </>
            }
          >
            <Tabs.TabPane
              destroyInactiveTabPane={true}
              tab={t('learning_admin_tab_module_series')}
              key={'module_serie'}
            >
              <LearningAdminHeaderList
                component='LearningAdminModuleSerieAddScreen'
                view={view}
                activeKey={activeKey}
                module={'module_serie'}
              />
              {view === 'grid' ? (
                <LearningAdminModuleSeriesGridScreen
                  setShowList={setShowList}
                  setGlobalTotal={setGlobalTotal}
                  view={view}
                  activeKey={activeKey}
                />
              ) : (
                <LearningAdminModuleSeriesTableScreen
                  page={page}
                  limit={limit}
                  order={order ?? 'is_recommended.desc'}
                  filter={filter}
                  setShowList={setShowList}
                  setGlobalTotal={setGlobalTotal}
                  component={component}
                  view={view}
                  activeKey={activeKey}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane
              destroyInactiveTabPane={true}
              tab={t('learning_admin_tab_modules')}
              key={'module'}
            >
              <LearningAdminHeaderList
                component='LearningAdminModuleAddScreen'
                view={view}
                activeKey={activeKey}
                module={'module'}
              />

              {view === 'grid' ? (
                <LearningAdminModulesGridScreen
                  setShowList={setShowList}
                  setGlobalTotal={setGlobalTotal}
                  view={view}
                  activeKey={activeKey}
                />
              ) : (
                <LearningAdminModulesTableScreen
                  page={page}
                  limit={limit}
                  order={order ?? 'order.asc'}
                  filter={filter}
                  setShowList={setShowList}
                  setGlobalTotal={setGlobalTotal}
                  component={component}
                  view={view}
                />
              )}
            </Tabs.TabPane>
          </Tabs>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminList);

Logger.log('silly', `LearningAdminList loaded.`);
